import { useState } from "react";

// Interfaces
import { ISectionContainer } from "./interfaces";

// Components
import RoundedBox from "@Layouts/components/Basics/RoundedBox";
import { CollapsibleSection, DeletableSection, TitleSection } from "./sections";
import OemDataHeaderIcon from "@DataPages/components/OEM/Tables/OemDataTable/OemDataHeaderIcon";

// MUI
import { Box, Collapse, Grid, Stack } from "@mui/material";

export default function SectionContainer(props: Readonly<ISectionContainer>) {
	const {
		children,
		sectionId = "",
		title = "",
		icon = null,
		iconHover = null,
		deleteTitle = "Delete Section",
		sx = undefined,
		sxTitle = undefined,
		collapsible = false,
		deletable = false,
		loading = false,
		readOnly = false,
		onDeleteAction = () => {},
		leftAlignment = false,
		brandIcon = null, 
	} = props;

	const [collapsed, setCollapsed] = useState(false);

	const handleDelete = () => {
		onDeleteAction?.(sectionId);
	};

	const handleExpandToggle = () => {
		setCollapsed(!collapsed);
	};

	return (
		<RoundedBox className="!px-[32px] !pt-[32px] !pb-[48px]" sx={sx}>
			<Collapse className="general-section-container" in={!collapsed} collapsedSize={40} timeout={100}>
				<Box sx={{ position: "relative" }}>
					<Grid container alignItems={"center"} sx={{ minHeight: "56px" }}>
						<Grid container direction="row" rowSpacing={2} justifyContent={"left"} alignItems={"center"}>
							{Boolean(title) && <TitleSection leftAlignment={leftAlignment} title={title} sx={sxTitle} loading={loading} />}
							{collapsible && leftAlignment && (
								<CollapsibleSection collapsed={collapsed} loading={loading} handleExpandToggle={handleExpandToggle} />
							)}
						</Grid>
						
						<Grid
							item
							sx={{
								position: "absolute",
								right: "0px",
							}}
						>
							<Stack direction={"row"} spacing={1}>
								{deletable && (
									<DeletableSection
										title={deleteTitle}
										icon={icon}
										iconHover={iconHover}
										loading={loading}
										readOnly={readOnly}
										onDeleteAction={handleDelete}
									/>
								)}
								{collapsible && !leftAlignment && (
									<CollapsibleSection collapsed={collapsed} loading={loading} handleExpandToggle={handleExpandToggle} />
								)}
								{brandIcon && (
									<OemDataHeaderIcon icon={brandIcon} />
								)}
							</Stack>
						</Grid>
					</Grid>

					<Grid container className={leftAlignment ? "section-container-content-left-align" : "section-container-content"}>
						<Grid item xs={12}>
							{children}
						</Grid>
					</Grid>
				</Box>
			</Collapse>
		</RoundedBox>
	);
}
